<template>
  <div>
    <div class="headline blue--text">Automatic Opt-in Process</div>

    <div class="ml-3">

      <div class="my-3">
        Your clients must opt in to receive text messages from your agency. We recommend using HawkSoft Text Messaging’s automated opt-in feature to send an opt in request the first time you communicate with a client. Alternatively, you may choose to gather opt-in from your clients through other means, but please be aware that any
        <span class="font-weight-bold"> fines or penalties imposed by telecom carriers because of non-compliance in collecting opt-ins will rest on your agency.</span>
      </div>
      <div class="my-3">
        You have three options to choose from to capture opt-in consent from your clients:
      </div>

      <table cellpadding="0" cellspacing="0">
        <tr style="vertical-align: top">
          <td nowrap class="font-weight-bold pr-4 py-2">Option 1:</td>
          <td class="py-2">Require HawkSoft to send an automated opt-in message the first time you communicate with a client. Recommended method to ensure your agency stays compliant with federal regulations.</td>
        </tr>
        <tr style="vertical-align: top">
          <td nowrap class="font-weight-bold pr-4 py-2">Option 2:</td>
          <td class="py-2">Allow your agency staff to choose to accept the legal responsibility and give them the option to skip HawkSoft's automatic opt-in process.</td>
        </tr>
        <tr style="vertical-align: top">
          <td nowrap class="font-weight-bold pr-4 py-2">Option 3:</td>
          <td class="py-2">Accept legal responsibility for your agency and remove HawkSoft's automatic opt-in process.</td>
        </tr>
      </table>

      <div class="pt-4">
        <span class="font-weight-bold">Note:</span>
        Regardless of the option selected, if an insured opts out, you will be required to complete HawkSoft's automatic opt-in process to resume communication with them.
      </div>
    </div>

    <div class="px-4 pt-4">
      <span>You can change your selection later by returning to the HawkSoft Text Messaging feature in the Marketplace.</span>
      <v-radio-group v-model="optInMode" :messages="msg">
        <v-radio label="1. (Recommended) Require opt in before sending a message to any client" :value="1"></v-radio>
        <v-radio label="2. Allow my users to accept legal liability for the agency and skip the automated opt-in process" :value="0"></v-radio>
        <v-radio label="3. Accept legal liability on behalf of my agency and disable the opt-in requirement for text messaging" :value="2"></v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TSOptIn',
  props: {
    value: {
      type: Number,
      default: 1
    },
    msg: {
      type: String,
      default: ''
    }
  },
  computed: {
    optInMode: {
      get () {
        return this.value;
      },
      set (v) {
        this.$emit('change', v);
      }
    }
  }
};
</script>
